module.exports = __webpack_public_path__ + "img/qr-icon.ab1abffe.svg";